import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";
import {MutasiBarangStatus} from "../../../common/Constants";
import { getMutasiStatusOptions } from "../config";

class MutasiBarangFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cabangOptions: [],
            locatorSourceOptions: [],
            locatorTargetOptions: [],
            kodeVariantOptions: [],
            variantOptions: [],
            kodeKSUOptions: [],
            kodeHadiahOptions: [],
            kodeBarangLainOptions: [],
            variantName: "",
            ksuName: "",
            hadiahName: "",
            otherName: "",
            allLocatorBased: [],
        };
    }

    async componentDidMount() {
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {},
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllVariant(),
            Api.create("NAGAMAS_MASTER_DATA").getAllKSU(),
            Api.create("NAGAMAS_MASTER_DATA").getAllHadiah(),
            Api.create("NAGAMAS_MASTER_DATA").getAllOtherItemPagingByParam({
                paramFilters: {},
            }),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: responses[0].data.data.map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
            }));
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.props.mutasiKeluarTab ?
                this.setState((prevValue) => ({
                    ...prevValue,
                    allLocatorBased: responses[1].data.data,
                    locatorSourceOptions: responses[1].data.data.filter(loc => loc.kodeCabang === this.props.state.filterData.sourceKodeCabang?.value)
                        .map((l) => mapToObjectDDL(l.nameLocation, l.kodeLocation)
                        ),
                })) :
                this.setState((prevValue) => ({
                    ...prevValue,
                    allLocatorBased: responses[1].data.data,
                    locatorTargetOptions: responses[1].data.data.filter(loc => loc.kodeCabang === this.props.state.filterData.targetKodeCabang?.value)
                        .map((l) => mapToObjectDDL(l.nameLocation, l.kodeLocation)
                        ),
                }))
        }

        if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeVariantOptions: responses[2].data.data.map((kv) =>
                    mapToObjectDDL(`${kv.kodeVariant} - ${kv.namaVariant}`, kv.kodeVariant)
                )
            }));
        }

        if (responses[3].ok && !R.isEmpty(responses[3].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeKSUOptions: responses[3].data.data.map((ksu) =>
                    mapToObjectDDL(`${ksu.kodeKSU} - ${ksu.name}`, ksu.kodeKSU)
                )
            }));
        }

        if (responses[4].ok && !R.isEmpty(responses[4].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeHadiahOptions: responses[4].data.data.map((h) =>
                    mapToObjectDDL(`${h.kodeHadiah} - ${h.nameHadiah}`, h.kodeHadiah)
                )
            }));
        }

        if (responses[5].ok && !R.isEmpty(responses[5].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeBarangLainOptions: responses[5].data.data.map((bl) =>
                    mapToObjectDDL(`${bl.kodeotheritem} - ${bl.nameotheritem}`, bl.kodeotheritem)
                ),
            }));
        }
    }

    getFilterDataValue(fieldName, fallbackValue = "") {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    }

    changeCabangAsal = (name, value) => {
        value != null ? this.setState((prevValue) => ({
            ...prevValue,
            locatorSourceOptions: this.state.allLocatorBased.filter(loc => loc.kodeCabang == value.value)
                .map((l) => mapToObjectDDL(l.nameLocation, l.kodeLocation))
        })) : this.setState((prevValue) => ({
            ...prevValue,
            locatorSourceOptions: []
        }))
        this.props.onValueChange(name, value)
    }

    changeCabangTujuan = (name, value) => {
        value != null ? this.setState((prevValue) => ({
            ...prevValue,
            locatorTargetOptions: this.state.allLocatorBased.filter(loc => loc.kodeCabang == value.value)
                .map((l) => mapToObjectDDL(l.nameLocation, l.kodeLocation))
        })) : this.setState((prevValue) => ({
            ...prevValue,
            locatorTargetOption: []
        }))
        this.props.onValueChange(name, value)
    }

    render() {
        const statusOptions = getMutasiStatusOptions(this.props.mutasiKeluarTab);
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.state.filterVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <form onSubmit={this.props.onSubmit}>
                            <SimpleInput
                                id="input_text_no_mutasi"
                                name="noMutation"
                                label="No. Mutasi"
                                value={this.getFilterDataValue("noMutation")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <FlexView column vAlignContent="center">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Tgl. Mutasi:</h4>
                                </div>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        id="select_date_tglmutasi_from"
                                        name="startMutation"
                                        nextdate
                                        date={this.getFilterDataValue("startMutation")}
                                        maxDate={this.getFilterDataValue("endMutation")}
                                        onChange={(value) => this.props.onValueChange("startMutation", value)}
                                    />
                                    <span className="margin-bottom-20px">s/d</span>
                                    <SimpleDate
                                        id="select_date_tglmutasi_to"
                                        name="endMutation"
                                        nextdate
                                        date={this.getFilterDataValue("endMutation")}
                                        onChange={(value) => this.props.onValueChange("endMutation", value)}
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleDDL
                                id="select_options_cabang_asal"
                                name="sourceKodeCabang"
                                label="Cabang Asal"
                                box="search"
                                isClearable
                                options={this.state.cabangOptions}
                                value={this.getFilterDataValue("sourceKodeCabang", null)}
                                onChange={(value, {name}) => this.changeCabangAsal(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_locator_asal"
                                name="sourceKodeLocator"
                                label="Locator Asal"
                                box="search"
                                isClearable
                                options={this.state.locatorSourceOptions}
                                value={this.getFilterDataValue("sourceKodeLocator", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_cabang_tujuan"
                                name="targetKodeCabang"
                                label="Cabang Tujuan"
                                box="search"
                                isClearable
                                options={this.state.cabangOptions}
                                value={this.getFilterDataValue("targetKodeCabang", null)}
                                onChange={(value, {name}) => this.changeCabangTujuan(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_locator_tujuan"
                                name="targetKodeLocator"
                                label="Locator Tujuan"
                                box="search"
                                isClearable
                                options={this.state.locatorTargetOptions}
                                value={this.getFilterDataValue("targetKodeLocator", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_status"
                                name="mutationStatus"
                                label="Status"
                                box="search"
                                isClearable
                                options={statusOptions}
                                value={this.getFilterDataValue("mutationStatus", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <h3>Filter Detail</h3>
                            <SimpleDDL
                                id="select_options_kode_varian"
                                name="variantCode"
                                box="search"
                                label="Kode Varian"
                                options={this.state.kodeVariantOptions}
                                value={this.getFilterDataValue("variantCode", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_no_mesin"
                                name="engineNumber"
                                label="No. Mesin"
                                value={this.getFilterDataValue("engineNumber")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_no_rangka"
                                name="frameNumber"
                                label="No. Rangka"
                                value={this.getFilterDataValue("frameNumber")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <SimpleDDL
                                id="select_options_kode_ksu"
                                name="kodeKsu"
                                label="Kode KSU"
                                box="search"
                                options={this.state.kodeKSUOptions}
                                value={this.getFilterDataValue("kodeKsu", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                buttonText={this.state.ksuName}
                            />
                            <SimpleDDL
                                id="select_options_kode_hadiah"
                                name="kodeHadiah"
                                label="Kode Hadiah"
                                box="search"
                                options={this.state.kodeHadiahOptions}
                                value={this.getFilterDataValue("kodeHadiah", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                buttonText={this.state.hadiahName}
                            />
                            <SimpleDDL
                                id="select_options_kode_barang_lain"
                                name="kodeBarang"
                                label="Kode Barang Lain"
                                box="search"
                                options={this.state.kodeBarangLainOptions}
                                value={this.getFilterDataValue("kodeBarang", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                buttonText={this.state.otherName}
                            />
                            <SimpleInput
                                id="input_text_qr_code"
                                name="qrCode"
                                label="QR Code"
                                value={this.getFilterDataValue("qrCode")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton type="button" onClick={this.props.onReset}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton type="submit">Terapkan</SimpleButton>
                            </FlexView>
                        </form>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MutasiBarangFilter;
